import { render } from "./ProductView.vue?vue&type=template&id=46ac0b7e"
import script from "./ProductView.vue?vue&type=script&lang=js"
export * from "./ProductView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__